import { Call, ApiUrl, ParseGeneralResponse } from './ApiUtils';

export function getUserProfile(id) {
  const url = ApiUrl(`users/${id}`);
  return Call('get', url, {}, ParseGeneralResponse, { responseDataKeys: { data: '' } }, true);
}

export function addUser(data) {
  const url = ApiUrl('users');
  return Call('post', url, data, ParseGeneralResponse, { responseDataKeys: { data: '' } }, true);
}

export function updateUser(data, id) {
  const url = ApiUrl(`users/${id}`);
  return Call('put', url, data, ParseGeneralResponse, { responseDataKeys: { data: '' } }, true);
}

